import React, { Component } from 'react'

export default class Client extends Component {
  render() {
    return (
      <div>
  <div className="client-logo-section" style={{backgroundColor: '#344'}}>
    <div className="container">
      <div className="client-logo-wrapper">
        <div className="client-logo-carousel d-flex align-items-center justify-content-between">
          <div className="client-logo">
            <img src="assets/images/client-logo/client-1.svg" alt="#" />
          </div>
          <div className="client-logo">
            <img src="assets/images/client-logo/client-2.svg" alt="#" />
          </div>
          <div className="client-logo">
            <img src="assets/images/client-logo/client-3.svg" alt="#" />
          </div>
          <div className="client-logo">
            <img src="assets/images/client-logo/client-4.svg" alt="#" />
          </div>
          <div className="client-logo">
            <img src="assets/images/client-logo/client-5.svg" alt="#" />
          </div>
          <div className="client-logo">
            <img src="assets/images/client-logo/client-6.svg" alt="#" />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

    )
  }
}
